import { connect } from 'react-redux';
import CaseMetricsDeltasComponent from './../Components/CaseMetricsDeltasComponent';
import {
  caseMetricsPageReducer,
  getCaseMetricsScanMetrics
} from './../reducers';
import { modal as modalActions } from './../actions';

const getPercentageDelta = (prim, sec) =>
  parseFloat(100 * (prim - sec) / sec).toPrecision(4);

export const mapStateToProps = (state) => {
  const selected = caseMetricsPageReducer.getCaseSelectedJobs(state);
  const jobs = getCaseMetricsScanMetrics(state);

  const primary = selected[0] ? jobs[selected[0].index] : undefined;
  const secondary = selected[1] ? jobs[selected[1].index] : undefined;

  // we want runtime durations for delta calulcations, these are search + decryption times
  const ccfDurDelta = primary && secondary ?
    getPercentageDelta(primary.ccf.runtime, secondary.ccf.runtime) :
    0;
  const ncfDurDelta = primary && secondary ?
    getPercentageDelta(primary.ncf.runtime, secondary.ncf.runtime) :
    0;

  return {
    // if selection without index then it is a url given selection, don't display
    primaryName: selected[0] ?
      selected[0].index >= 0 ? selected[0].value : undefined :
      undefined,
    secondaryName: selected[1] ? selected[1].value : undefined,
    ccfDurDelta: `${ccfDurDelta > 0 ? '+' : ''}${ccfDurDelta}`,
    ncfDurDelta: `${ncfDurDelta > 0 ? '+' : ''}${ncfDurDelta}`,
    ccfHitDelta: primary && secondary ?
      primary.ccf.hitCount - secondary.ccf.hitCount :
      0,
    ncfHitDelta: primary && secondary ?
      primary.ncf.hitCount - secondary.ncf.hitCount :
      0,
    sourceDelta: primary && secondary ?
      primary.ncf.sourceCount - secondary.ncf.sourceCount :
      0,
    sourceAttributeDelta: primary && secondary ?
      primary.ncf.sourceAttributeCount - secondary.ncf.sourceAttributeCount :
      0
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onLinkClick: (isCcf) => dispatch(
      modalActions.showArtifactHitCountModal(true, undefined, isCcf)
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseMetricsDeltasComponent);


// WEBPACK FOOTER //
// src/Containers/CaseMetricsDeltasContainer.jsx